// extracted by mini-css-extract-plugin
module.exports = {"section":"ContactForm-module--section--2ngC_","subheading":"ContactForm-module--subheading--18I1f","grid":"ContactForm-module--grid--5wCLt"};